import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";
import { getRestaurantSettings } from "../../../services/profile.services";
import { useDispatch } from "react-redux";
import { addRestData } from "../../../../../redux/slices/restSettings";
import { LOADER_TIMEOUT_TIME, SWAL_SETTINGS } from "../../../../../utils/Constants";
import { useFormik } from "formik";
import { updateCurrencyValues } from "../../../services/tipStatus.service";
import { handleServerValidations } from "../../../../../utils/commonfunction";
import Swal from "sweetalert2";

const PreDefineCurrencyValues = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [Loader, setLoader] = useState(false);
  const [addSubmissionLoader, setAddSubmissionLoader] = useState(false);
  const [refreshSettings, setRefreshSettings] = useState(false);

  // NEW STATE FOR MULTIPLE INPUTS
  const [extraInputs, setExtraInputs] = useState([100]); // default 1 input

  useEffect(() => {
    setLoader(true);

    getRestaurantSettings()
      .then((response) => {
        dispatch(addRestData(response.data));
        // Predefined currencies coming from restaurant settings
        if (response?.data?.predefinedCurrencies?.length > 0) {
          setExtraInputs(response.data.predefinedCurrencies);
        }
        setTimeout(() => setLoader(false), LOADER_TIMEOUT_TIME);
      })
      .catch((error) => {
        setTimeout(() => setLoader(false), LOADER_TIMEOUT_TIME);
        console.error("Error===>", error);
      });
  }, [refreshSettings]);

  // ➤ FORM SUBMIT
  const formPreDefineCurrencyValues = useFormik({
    initialValues: {},
    enableReinitialize: true,

    onSubmit: () => {
      // Validation: All must be numbers
      if (hasEmptyInput) {
        Swal.fire({
          icon: "error",
          text: "Please fill all currency values before submitting.",
          ...SWAL_SETTINGS,
        });
        return;
      }
      const numValues = extraInputs.map((v) => Number(v)).filter((x) => !isNaN(x));

      if (numValues.length !== extraInputs.length) {
        Swal.fire({ icon: "error", text: "All values must be valid numbers.", ...SWAL_SETTINGS });
        return;
      }

      setAddSubmissionLoader(true);

      const formData = new FormData();
      formData.append("predefinedCurrencies", JSON.stringify(numValues)); // pass array

      updateCurrencyValues(formData)
        .then((response) => {
          setAddSubmissionLoader(false);

          if (response.success) {
            Swal.fire({
              icon: "success",
              text: response.message,
              ...SWAL_SETTINGS,
            });

            setRefreshSettings(!refreshSettings);
          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
          }
        })
        .catch((e) => {
          setAddSubmissionLoader(false);
          console.error("Error In Pre Defining Currency Values", e);
        });
    },
  });

  // ➤ ADD NEW INPUT
  const addNewInput = () => {
    if (extraInputs.length >= 5) {
      Swal.fire({
        icon: "warning",
        text: "You can add a maximum of 5 inputs.",
        ...SWAL_SETTINGS,
      });
      return;
    }

    setExtraInputs([...extraInputs, ""]); // add empty input
  };

  // ➤ UPDATE INPUT VALUE
  const handleInputChange = (value, index) => {
    if (isNaN(value)) return; // prevent entering non-numbers

    const updated = [...extraInputs];
    updated[index] = value;
    setExtraInputs(updated);
  };

  // ➤ REMOVE INPUT
  const removeInput = (index) => {
    const updated = extraInputs.filter((_, i) => i !== index);
    setExtraInputs(updated);
  };
  const hasEmptyInput = extraInputs.some((val) => val === "" || val === null || val === undefined);

  return (
    <main id="main-content">
      <div className="inner-container">
        <div className="page-header d-flex align-items-center">
          <h4 className="heading-title-text">Add Quick Currency Options</h4>
        </div>

        {Loader ? (
          <Skeleton height={50} className="m-2" />
        ) : (
          <div className="service-charges-box">
            <form onSubmit={formPreDefineCurrencyValues.handleSubmit}>
              <div className="card">
                <div className="card-body">
                  {/* --------------------- NEW MULTIPLE INPUT SECTION ------------------------ */}
                  <label className="form-label fw-bold mb-2"> Add Currency Values</label>

                  {extraInputs.map((input, index) => (
                    <div key={index} className="d-flex mb-2 gap-2">
                      <input
                        type="number"
                        className="form-control"
                        value={input}
                        min="1"
                        step="1"
                        max="1000000"
                        onChange={(e) => handleInputChange(e.target.value, index)}
                        onKeyDown={(e) => {
                          if (e.key === "-" || e.key === "e") {
                            e.preventDefault();
                          }
                        }}
                        placeholder="Enter Currency Value"
                      />

                      {extraInputs.length > 1 && (
                        <button type="button" className="btn btn-primary rounded-circle" onClick={() => removeInput(index)}>
                          <i className="ri-close-large-line"></i>
                        </button>
                      )}
                    </div>
                  ))}

                  <button
                    type="button"
                    className="btn btn-secondary mt-2"
                    onClick={addNewInput}
                    style={{
                      backgroundColor: "#6c757d",
                      borderColor: "#6c757d",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = "#6c757d";
                      e.target.style.borderColor = "#6c757d";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = "#6c757d";
                      e.target.style.borderColor = "#6c757d";
                    }}>
                    + Add More
                  </button>

                  {/* ------------------------------------------------------------------------ */}
                </div>
              </div>

              <button type="submit" className={"btn btn-primary mt-4 " + (addSubmissionLoader ? " btn-loader" : "")}>
                Submit
              </button>
            </form>
          </div>
        )}
      </div>
    </main>
  );
};

export default PreDefineCurrencyValues;
